import { useEffect, useState } from "react";
import StarRating from "../PoojaComponent/PoojaStarComponent";
import { useRouter } from "next/router";

const { default: ImageWrapper } = require("../ImageComponent/ImageWrapper");

const TestimonialBox = (props) => {
  const { data, handleMoreButton } = props;
  const [isHovered, setISHovered] = useState(false);
  const [contentSize, setContentSize] = useState(200);
  const router = useRouter();
  const isAboutUsPage = router.pathname.includes("about-us");

  const hoverSize =
    data?.testimonial?.length < 200
      ? 250
      : data?.testimonial?.length < 300
      ? 300
      : data.testimonial.length < 400
      ? 400
      : 500;

  useEffect(() => {
    if (router.asPath.includes("about-us")) {
      setContentSize(1000);
    }
  }, [router]);

  return (
    <div
      onMouseEnter={() => setISHovered(true)}
      onMouseLeave={() => setISHovered(false)}
      className={`flex flex-col md:w-full h-full lg:h-64 hover:h-full transition-all duration-700 shadow-lg bg-slate-100 border hover:scale-105 hover:cursor-pointer rounded-xl p-4 `}
    >
      <div className="flex flex-row items-start mb-2">
        <div className="w-10 h-10 xl:w-20 xl:h-20 overflow-hidden rounded-xl mr-4 mt-1 relative">
          <ImageWrapper
            className="rounded-xl object-cover w-full h-full"
            src={
              data.image && data.image !== "" ? data.image : "/icons/user.svg"
            }
            alt={data.name}
          />
        </div>

        <div className="flex flex-col flex-grow">
          <div className="flex flex-row items-center justify-between">
            <h3 className="font-sembold text-xl text-Default tracking-wide">
              {data.name}
            </h3>
            <div className="flex items-center gap-2">
              <StarRating
                rating={data.rating}
                defaultStars={5}
                canChangeRating={false}
              />
            </div>
          </div>
          <div className="flex flex-row gap-2">
            <h3 className="font-normal capitalize text-sm text-Default tracking-wide">
              {data.location}
            </h3>
            <h3 className="font-normal capitalize text-sm text-Default tracking-wide">
              {data.language}
            </h3>
          </div>
        </div>
      </div>

      <div className="flex flex-col flex-grow overflow-hidden">
        <h3 className="text-BluntRed tracking-wide pb-1 font-semibold capitalize">
          {data.highlight}
        </h3>
        <p
          className={`text-left font-normal text-sm leading-5 font-roboto tracking-0 ${
            isHovered ? "text-gray-800" : "text-Default"
          }`}
        >
          {data.testimonial && data.testimonial.length > contentSize
            ? data.testimonial.slice(0, contentSize) + "..."
            : data.testimonial}
        </p>
      </div>
    </div>
  );
};

export default TestimonialBox;
